import React from 'react';
import Locale from '../../Translate/Locale';
import Link from '../../common/Link/Link';
import Button from '../../common/Button/Button';
import AnalyticsIcon from '../../../icons/homepage/analytics.svg';

import './NewReleaseBanner.scss';

function NewReleaseBanner() {
  return (
    <div styleName="container">
      <div styleName="icon-circle" >
        <AnalyticsIcon />
      </div>
      <div styleName="text-container">
        <div styleName="heading"><Locale>ANALYTICS_COUNTRY_VIEWS_BANNER_HEADER</Locale></div>
        <div styleName="description"><Locale>ANALYTICS_COUNTRY_VIEWS_BANNER_DESCRIPTION</Locale></div>
      </div>
      <div styleName="cta">
        <Link to="/analytics/dashboards/country_view_france">
          <Button midnight>
            ANALYTICS_COUNTRY_VIEWS_BANNER_CTA
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default React.memo(NewReleaseBanner);